import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { translate } from 'react-i18next';
import PagesLayout from './PagesLayout';

const MajakLink = ({ t }) => <Link to="/">{t('Majak.sk')}</Link>;
const MajakLinkT = translate()(MajakLink);

const MajakEmail = ({ t }) => <a href="mailto:info@majak.sk">{t('info@majak.sk')}</a>;
const MajakEmailT = translate()(MajakEmail);

const ReklamacnyPoriadok = ({ t }) => (
  <PagesLayout className="reklamacny">
    <h2>{t('Reklamačný poriadok')}</h2>
    <p>
      {t(
        'Spoločnosť Peer2Peer, s.r.o., Mostová 2, 811 02 Bratislava, IČO 50752111, prevádzkovateľ portálu'
      )}{' '}
      <MajakLinkT /> {t('(ďalej aj „spoločnosť“) vydáva tento reklamačný poriadok.')}
    </p>
    <p>
      {t(
        'Reklamačný poriadok obsahuje informácie o podmienkach a spôsobe reklamácie a údaje o tom, kde možno reklamáciu uplatniť.'
      )}
    </p>
    <p>
      {t(
        'Reklamačný poriadok upravuje vzťahy medzi spoločnosťou a jej klientmi vyplývajúce z reklamačného konania.'
      )}
    </p>
    <p>{t('Reklamáciou sa rozumie uplatnenie zodpovednosti za vadu služby.')}</p>
    <p>
      {t(
        'Reklamáciu klient podáva písomne na adresu spoločnosti: Peer2Peer, s.r.o., Mostová 2, 811 02 Bratislava alebo elektronicky na e-mailovú adresu'
      )}{' '}
      <MajakEmailT />.
    </p>
    <p>
      {t(
        'Z reklamácie musí byť zrejmé, kto reklamáciu podáva, čo je jej obsahom a čoho sa domáha. K reklamácii je priložiť doklady preukazujúce pravdivosť tvrdení klienta. Klient uplatňuje reklamáciu bezodkladne ako sa o vade jemu poskytovanej služby dozvedel.'
      )}
    </p>
    <p>
      {t(
        'Uplatnenie reklamácie nezbavuje dlžníka povinnosti plniť si svoje záväzky voči spoločnosti.'
      )}
    </p>
    <p>
      {t(
        'Lehota na vybavenie reklamácie je 30 dní od podania reklamácia a táto lehota začína plynúť dňom doručenia reklamácie. Spoločnosť vydá klientovi doklad o vybavení reklamácie najneskôr do 30 dní odo dňa uplatnenia reklamácie.'
      )}
    </p>
    <p>{t('Náklady spojené s reklamáciou znáša spoločnosť.')}</p>
    <p>{t('Spoločnosť si vyhradzuje právo na zmenu Reklamačného poriadku.')}</p>
    <p>{t('Tento reklamačný poriadok nadobúda účinnosť 1.9.2017.')}</p>
  </PagesLayout>
);

ReklamacnyPoriadok.propTypes = {
  t: PropTypes.func.isRequired,
};

export default translate()(ReklamacnyPoriadok);



// WEBPACK FOOTER //
// ./src/features/pages/ReklamacnyPoriadok.js